import React from "react";
import { ArrowRight, Sparkles, X } from "lucide-react";
import HelpTip from "src/stage/HelpTip";
import { TEMPLATE_EXAMPLES } from "../templateExamples";

// AUTO-WA-39: "Start from an example" — ready-made templates to adapt.
const fill = (text, values) => text.replace(/\{\{(\d+)\}\}/g, (whole, key) => values[Number(key) - 1] || whole);

export default function TemplateExamples({ onUse, onClose }) {
  return (
    <section className="ws-card wa-examples ws-rise" aria-label="Start from an example">
      <div className="wa-card-head">
        <span className="ws-icon-tile" aria-hidden="true"><Sparkles size={18} /></span>
        <div className="ws-grow">
          <h2 className="ws-h3">Start from an example <HelpTip term="category" /></h2>
          <p className="ws-muted">Pick one, change the words to fit your business, then send it to Meta for approval. Utility messages cost less than marketing ones.</p>
        </div>
        {onClose && <button type="button" className="ws-row-more" aria-label="Hide examples" onClick={onClose}><X size={15} /></button>}
      </div>
      <div className="wa-examples-grid">
        {TEMPLATE_EXAMPLES.map((example) => (
          <button key={example.id} type="button" className="wa-example" onClick={() => onUse(example)}>
            <span className="wa-example-top">
              <span className={`wa-cat wa-cat--${example.category.toLowerCase()}`}>{example.category.toLowerCase()}</span>
              <ArrowRight size={15} className="wa-example-go" aria-hidden="true" />
            </span>
            <strong>{example.title}</strong>
            <span className="ws-muted">{example.use}</span>
            <span className="wa-example-bubble"><span>{fill(example.body, example.examples)}</span></span>
          </button>
        ))}
      </div>
    </section>
  );
}
